import PropTypes from "prop-types";
import React from "react";
import { FaAngleDown } from "react-icons/fa6";

const Dropdown = (props) => {
  const setDropdown = (e) => {
    const element = document.activeElement;
    if (element) element?.blur();
    props.onChange(e);
  };

  return (
    <div className="col-span-4 w-full">
      <div className="flex flex-col dropdown dropdown-bottom">
        <p className="text-neutral-700 font-medium mb-1">{props.title}</p>

        <label className="input input-bordered flex items-center gap-2 focus-within:outline-none w-full text-neutral-700">
          <input
            tabIndex={0}
            role="button"
            className="grow"
            placeholder={props.placeholder}
            value={props.value ?? ""}
            readOnly
          />
          <FaAngleDown className="text-neutral-600 text-lg" />
        </label>

        <ul
          tabIndex={0}
          className="dropdown-content w-full max-w-xs z-[1] menu p-2 shadow bg-base-100 rounded-box"
        >
          {props.list.map((item, key) => (
            <li key={key} onClick={() => setDropdown(item)}>
              <a className="text-neutral-700">{item.name}</a>
            </li>
          ))}
        </ul>
      </div>
      {props.error && (
        <p className="text-sm font-medium text-error mt-[2px]">{props.error}</p>
      )}
    </div>
  );
};

export default Dropdown;

Dropdown.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  list: PropTypes.array,
  onChange: PropTypes.func,
};
